const translations = {
    inFlightLabel: 'In Flight',
    landingLabel: 'Landing',
    noneLabel: 'None',
    takeoffLabel: 'Take Off'
};

export default translations;
